
import * as Comlink from 'comlink';

import WebGLEntity from './WebGLEntity.js';
import {downloadField} from './utils.js';

import Worker from './EnvironmentPlot.worker.js';

const layer_worker = Comlink.wrap(new Worker());

class Field extends WebGLEntity {
    static downloader = downloadField;

    constructor(field, args) {
        super();
        this.field = field;
        Object.assign(this, args);

        this.is_initialized = false;
    }

    onAdd(map, gl) {}

    render(gl, matrix) {}
}

export { Field, layer_worker };